export default class ComandoAPI {
    constructor(servicioApi) {
        this.servicioApi = servicioApi;
        // this.servicioApi = null;
    }

    ejecutar() {
        //implementar
    }

    cancelar() {
        //Puede reemplazarse en un Presentador si se necesita respuestas en la interfaz al cancelar
        if (this.servicioApi) {
            this.servicioApi.cancelar();
        }
    }
}
